import React from 'react';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { PayNowStatus, PolicyStatus } from '@acorn-portal/shared/src/services/api';
import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { useNavigate } from 'react-router';
import { IPayNow } from '@acorn-portal/shared/src/store/paynow.slice';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';

interface IncreaseMileageButtonProps {
	payNowDetails: IPayNow;
}

const IncreaseMileageButton: React.FC<IncreaseMileageButtonProps> = ({ payNowDetails }) => {
	const theme = useTheme();
	const fullPolicy = useAppSelector((x) => x.fullPolicy);
	const navigate = useNavigate();

	const showMileageButton = (): boolean => {
		const isTelematicsOrCarrot = fullPolicy.product === Product.TELEMATICS || fullPolicy.product === Product.CARROT;

		const isActivePolicy = fullPolicy.policyStatus === PolicyStatus.Active;

		const isNotDirectDebitOverdue = payNowDetails.details?.status !== PayNowStatus.DirectDebitOverdue;

		const isNotShortTermPolicy = !fullPolicy.isShortTermPolicy;

		return isTelematicsOrCarrot && isActivePolicy && isNotDirectDebitOverdue && isNotShortTermPolicy;
	};

	if (!showMileageButton()) {
		return null;
	}

	return (
		<Button
			variant='outlined'
			color='primary'
			fullWidth
			sx={{
				whiteSpace: 'nowrap',
				marginX: 'auto',
				p: 1,
				fontSize: 17,
				textTransform: 'capitalize',
				fontWeight: 600,
				border: `2px solid ${theme.palette.primary.main}`,
				'&:hover': {
					backgroundColor: 'transparent',
					border: `2px solid ${theme.palette.primary.main}`,
				},
				'&.MuiButton-outlined': {
					border: `2px solid ${theme.palette.primary.main}`,
				},
			}}
			type='button'
			onClick={() => navigate(ROUTE_PATHS.topUpMilesDate)}
		>
			Top Up Miles
		</Button>
	);
};

export default IncreaseMileageButton;
